export const lintSourceConfig = {
    delay: 50,
    markerFilter(diagnostics) {
        return diagnostics.filter((diagnostic) => diagnostic.severity === "error");
    },
    tooltipFilter() {
        return [];
    },
    needsRefresh(update) {
        return update.selectionSet;
    },
};
